import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { MdDeleteOutline } from "react-icons/md";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
import "./Inventory.css";

export const BulkReorder = () => {
  // add row of reorder
  const [reorderStockRow, setReorderStockRow] = useState([
    {
      id: 1,
      productCode: "001",
      product: "",
      category: "",
      uom: "",
      currentStock: "",
      minimumStock: "",
      qty: "",
      defaultCost: "",
      total: "",
    },
  ]);
  // Add stock  new row
  const handleReorderStockRow = () => {
    setReorderStockRow((prevRows) => [
      ...prevRows,
      {
        id: Date.now(), //it creates a unique ID based on the exact millisecond the row was added.
        productCode: "",
        product: "",
        category: "",
        uom: "",
        currentStock: "",
        minimumStock: "",
        qty: "",
        defaultCost: "",
        total: "",
      },
    ]);
  };

  // Delete add stock row
  const handleDeleteReorderRow = (id) => {
    setReorderStockRow((prevRows) => prevRows.filter((row) => row.id !== id));
  };

  return (
    <div className="inventoryContainer">
      <div className="container">
        <div className="d-flex gap-1 mb-2">
          <span className="me-2">
            <Link to="/state-inventory" style={{ color: "black" }}>
              <FaArrowLeftLong />
            </Link>
          </span>
          <div className="addModalTitle">Re-Order Stock</div>
        </div>

        {/* Reference No & Date */}
         <div className="bulkAddGrid">
          <div>
            <label>Reference No.</label>
            <input type="text" placeholder="Enter Reference No." />
          </div>
          <div>
            <label>Received Date</label>
            <input type="date" />
          </div>
        </div>
          <div className="bulkAddGrid">
          <div>
            <label>Priority</label>
            <select>
              <option>Select</option>
            </select>
          </div>
          <div>{""}</div>
        </div>
        {/* Table */}

        <div className="dashboardTableContainer">
          <TableContainer component={Paper}>
            <Table
              // sx={{ minWidth: 650 }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead className="dashboadTableHeader">
                <TableRow>
                  <TableCell>Product Code</TableCell>
                  <TableCell align="left">Product</TableCell>
                  <TableCell align="left">Category</TableCell>
                  <TableCell align="left">UOM</TableCell>
                  <TableCell align="left">Current Stock</TableCell>
                  <TableCell align="left">Minimum Stock</TableCell>
                  <TableCell align="left">Qty</TableCell>
                  <TableCell align="left">Default Cost Price / Unit</TableCell>
                  <TableCell align="left">Total Cost</TableCell>
                  <TableCell align="left">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reorderStockRow.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                    className="dashboardTableBody"
                  >
                    <TableCell align="left">
                      <select
                        className="addModalQtySelect"
                        value={row.productCode}
                      >
                        <option value="001">001</option>
                        <option value="002">002</option>
                      </select>
                    </TableCell>

                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.product}
                          placeholder="Product"
                        />
                      </span>
                    </TableCell>

                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.category}
                          placeholder="Category"
                        />
                      </span>
                    </TableCell>

                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input type="text" value={row.uom} placeholder="UOM" />
                      </span>
                    </TableCell>
                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.currentStock}
                          placeholder="Current Stock"
                        />
                      </span>
                    </TableCell>
                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.minimumStock}
                          placeholder="Minimum Stock"
                        />
                      </span>
                    </TableCell>
                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input type="text" value={row.qty} placeholder="Qty" />
                      </span>
                    </TableCell>

                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.defaultCost}
                          placeholder="Cost"
                        />
                      </span>
                    </TableCell>

                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.total}
                          placeholder="Total"
                        />
                      </span>
                    </TableCell>

                    <TableCell align="left">
                      <MdDeleteOutline
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDeleteReorderRow(row.id)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        {/* Add Row Button */}
        <div
          className="addRowText"
          onClick={handleReorderStockRow}
          style={{ cursor: "pointer" ,marginTop:'10px'}}
        >
          + Add Row
        </div>

        {/* Totals */}
        <div className="addModalTotalContainer">
          <div>
            <div className="addModalContent">
              <span>Total Products Requested:</span>
              <span>2 nos</span>
            </div>
            <div className="addModalContent">
              <span>Total Requested Qty:</span>
              <span>2400 nos</span>
            </div>
            <div className="addModalContent">
              <span>Total Value:</span>
              <span>₹9,60,000</span>
            </div>
          </div>
        </div>

        {/* Notes */}
         <div className="bulkAddTextGrid">
          <div>
            <label>Additional Notes</label>
          </div>
          <div>
            <textarea placeholder="Type here" rows={4}></textarea>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-end">
          <div
            className="addModalButtons"
            style={{ marginTop: "20px", display: "flex", gap: "10px" }}
          >
            <button className="addBtnCancel">Cancel</button>
            <button className="addBtnSave"> Submit Request</button>
          </div>
        </div>
      </div>
    </div>
  );
};
